import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { CompareHero, CompareUniversity } from "@modules/study/compare";

const CompareUniversities = () => {
  return (
    <LayoutMain
      title="Compare University"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/compare/university`}
    >
      <CompareUniversity />
    </LayoutMain>
  );
};

export default CompareUniversities;
